import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { useDownloadFileContext } from "common/context/DownloadFileProvider"
import { useUsuarioByCurrent } from "hooks/useUsuarioByCurrent"
import FormCreacionDocumento from "../FormCreacionDocumento/FormCreacionDocumento"
import { TYPES_DOCUMENTOS } from "../FormCreacionDocumento/constant"

const CreacionPresupuesto = () => {
  const downloadFile = useDownloadFileContext()

  const { activeCompany } = useUsuarioEmpresaActiva()
  const { usuarioByCurrent } = useUsuarioByCurrent()

  const empresaActiva = usuarioByCurrent?.empresaActiva

  const fieldValue = {
    id: activeCompany.id,
    logo: activeCompany.logo,
    logoAsBase64: activeCompany.logoAsBase64,
    ...(empresaActiva && { ...empresaActiva }),
  }

  return (
    <FormCreacionDocumento
      type={TYPES_DOCUMENTOS.PRESUPUESTO}
      empresaActiva={fieldValue}
      // @ts-expect-error TS(2322): Type '{ type: string; empresaActiva: { id: string ...
      downloadFile={downloadFile}
      documento={null}
    />
  )
}

export default CreacionPresupuesto
